import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import Checkbox from '@material-ui/core/Checkbox';
import Delete from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import PaddedGrid from '../components/PaddedGrid';
import MenuItemAdder from '../components/MenuItemAdder';
import WasteItemAdder from '../components/WasteItemAdder';
import { withStyles } from '@material-ui/core';
import Loading from '../components/Loading';
import { BUFFET, ALACARTE, BOTH } from '../constants/RestaurantType';
import AppContext from '../AppContext';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormatDate from '../FormatDate';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    inputField: {
        maxWidth: '150px'
    },

    generalContainer: {
        margin: theme.spacing.unit * 2,
        padding: theme.spacing.unit * 3,
        backgroundColor: '#eeeeee'
    },

    footerPlaceholder: {
        height: '100px'
    },

    footerContainer: {
        position: 'fixed',
        left: 0,
        bottom: 0,

        margin: 0,
        backgroundColor: '#c6dac3'
    }
});

class Report extends Component {
    constructor(props) {
        super(props);

        this.restaurantId = props.match.params.restaurantId;
        this.reportId = props.match.params.reportId;

        this.state = {
            loading: true,
            redirect: false,
            modalBuffet: false,
            modalAlacarte: false,
            modalKitchenWaste: false,
            modalStorageWaste: false,
            calculatorOpen: false,
            calculatorOriginalValue: '',
            calculatorAddedValue: '',
            calculatorUnit: 'kg',
            calculatorTitle: '',
            menus: { 1: [], 2: [] }
        };

        this.numberValidationHandler = this.numberValidationHandler.bind(this);
        this.saveReport = this.saveReport.bind(this);
    }

    reportChangeHandler(event, field, validation) {
        const target = event.target;
        let value =
            target.type === 'checkbox' ? target.checked : target.value;

        if (validation == 'number')
            value = this.numberValidate(value);

        let report = this.state.report;
        report[field] = value;

        this.setState({ report });
    }

    wasteChangeHandler(value, type, index, key) {
        let report = this.state.report;
        report.waste[type][index][key] = value;

        this.setState({ report });
    }

    otherWasteChangeHandler(key, index, value) {
        let { report } = this.state;
        report[key][index].wasted = value;

        this.setState({ report });
    }

    addWasteItem(key, item) {
        let { report } = this.state;
        report[key].push(item);

        this.setState({
            report,
            modalKitchenWaste: false,
            modalStorageWaste: false
        });
    }

    removeWaste(key, index) {
        let { report } = this.state;
        report[key].splice(index, 1);

        this.setState({ report });
    }

    addMenuItem(key, items) {
        let menu = this.state.menu;
        items = Array.isArray(items) ? items : [items];

        items.forEach((item) => menu[key].items.push(item));

        this.updateMenu(menu);
        this.setState({ modalBuffet: false, modalAlacarte: false });
    }

    destroyMenuItem(key, id) {
        let menu = this.state.menu;
        let report = this.state.report;

        const menu_index = menu[key].items.findIndex((item) => item.id == id);
        const waste_index = report.waste[key].findIndex((item) => item.menu_item_id == id);

        APIService.destroyMenuItem(this.restaurantId, menu[key].id, id)
            .then(() => {
                menu[key].items.splice(menu_index, 1);
                report.waste[key].splice(waste_index, 1);

                this.setState({
                    menu,
                    report
                });
            });
    }

    getStatisticsMessage(result) {
        const statisticMessages = [
            this.props.t('Hienoa että mittasit tänään! Hävikin seuraaminen auttaa saavuttamaan tavoitteesi!'),
            this.props.t('Hävikkiä on syntynyt tänään kg, keskiarvo aiempina päivinä kg.', { wasteToday: result.wasteToday, averageWaste: result.averageWaste })
        ];

        if (result.consecutiveDays > 1) {
            statisticMessages.push(this.props.t('Hienoa, olet mitannut jo päivää peräkkäin! Säännöllinen mittaaminen auttaa hävikin vähentämisessä!', { consecutiveDays: result.consecutiveDays }));
        }
        return statisticMessages[Math.floor(Math.random() * statisticMessages.length)];
    }

    showBanner() {
        APIService.getStatistics(this.restaurantId)
            .then((result) => AppContext.banner(this.getStatisticsMessage(result), false));
    }

    saveReport(quiet) {
        let report = Object.assign({}, this.state.report);
        report.waste = [...report.waste[BUFFET], ...report.waste[ALACARTE]];

        APIService.updateReport(
            this.restaurantId,
            this.reportId,
            report
        ).then(() => {
            if (quiet && !this.state.report.restaurant.notifications_disabled) {
                this.showBanner();
            }
            return quiet || AppContext.toast(this.props.t('Kirjauksesi on nyt tallennettu!'));
        }
        ).catch((e) =>
            quiet || AppContext.toast(`${this.props.t('Kirjauksesi ei tallentunut')}, ` + e)
        );
    }

    updateMenu(menu) {
        let report = this.state.report;
        let waste = report.waste || [];

        // Join existing waste data with the menu items
        report.waste = this.convertMenuToWaste(menu, waste);

        this.setState({
            report,
            menu,
        });
    }

    getFoodTypeForMenuItem(item) {
        if (!item || !item.food_type_id) {
            return null;
        }

        return this.state.foodTypes[item.food_type_id];
    }

    mapItems(item, wasteMappedByItemId) {
        let foodItemType = this.getFoodTypeForMenuItem(item).type;

        return {
            name: item.name,
            menu_item_id: item.id,
            food_type_id: item.food_type_id,

            produced: wasteMappedByItemId[foodItemType][item.id]
                ? wasteMappedByItemId[foodItemType][item.id].produced
                : null,

            wasted: wasteMappedByItemId[foodItemType][item.id]
                ? wasteMappedByItemId[foodItemType][item.id].wasted
                : null,

            gifted: wasteMappedByItemId[foodItemType][item.id]
                ? wasteMappedByItemId[foodItemType][item.id].gifted
                : null,
            price: item.price ? item.price : '',
            type: foodItemType
        };
    }

    convertMenuToWaste(menu, existingWaste) {
        if (!Array.isArray(existingWaste)) {
            existingWaste = [...existingWaste[1], ...existingWaste[2]];
        }

        const wasteMappedByItemId = existingWaste.reduce((acc, item) => {
            acc[item.type][item.menu_item_id] = item;
            return acc;
        }, { 1: {}, 2: {} });

        let newWaste = {
            1: menu[ALACARTE].items.map(item => this.mapItems(item, wasteMappedByItemId)),
            2: menu[BUFFET].items.map(item => this.mapItems(item, wasteMappedByItemId))
        };

        return newWaste;
    }

    openCalculator(originalValue, onUpdate, unit, title) {
        if (!originalValue) {
            return;
        }

        unit = unit || 'kg';
        title = title || '';

        this.onUpdate = onUpdate;
        this.setState({
            calculatorOpen: true,
            calculatorOriginalValue: originalValue,
            calculatorAddedValue: '',
            calculatorUnit: unit,
            calculatorTitle: title
        });
    }

    closeCalculator() {
        this.setState({ calculatorOpen: false });
        this.onUpdate(this.getCalculatorTotal());
    }

    getCalculatorTotal() {
        let { calculatorOriginalValue, calculatorAddedValue } = this.state;

        if (typeof calculatorOriginalValue === 'string')
            calculatorOriginalValue = calculatorOriginalValue.replace(',', '.');

        if (typeof calculatorAddedValue === 'string')
            calculatorAddedValue = calculatorAddedValue.replace(',', '.');

        calculatorOriginalValue = parseFloat(calculatorOriginalValue);
        calculatorAddedValue = parseFloat(calculatorAddedValue);

        calculatorOriginalValue = isNaN(calculatorOriginalValue) ? 0 : calculatorOriginalValue;
        calculatorAddedValue = isNaN(calculatorAddedValue) ? 0 : calculatorAddedValue;

        return calculatorOriginalValue + calculatorAddedValue;
    }

    numberValidate(val) {
        return val.replace(/[^\d.,]/, '').replace(',', '.');
    }

    numberValidationHandler(field) {
        let o = {};
        return (event) => {
            o[field] = event.target.value.replace(/[^\d,.]/, '');
            this.setState(o);
        };
    }

    destroyReport() {
        APIService.destroyReport(this.restaurantId, this.reportId)
            .then(() => {
                window.history.back();
            });
    }

    componentDidMount() {
        APIService.getFoodTypes(true)
            .then(types => {
                const foodTypes = types.reduce((acc, type) => {
                    acc[type.id] = type;
                    return acc;
                }, {});

                this.setState({
                    foodTypes
                });

                return APIService.getReport(this.restaurantId, this.reportId);
            })
            .then(report => {
                this.setState({ report });
                return APIService.getMenus(this.restaurantId, report.date);
            })
            .then(menus => {
                // Find the main menu for each type (where date_from === date_to)
                let alacarteMainMenu = menus.find((menu) => menu.type === ALACARTE && menu.date_from === menu.date_to) || { items: [] };
                let buffetMainMenu = menus.find((menu) => menu.type === BUFFET && menu.date_from === menu.date_to) || { items: [] };

                // Initialize arrays to hold aggregated menu items
                const alacarteItems = [];
                const buffetItems = [];

                // Aggregate items by menu type
                if (menus && menus.length > 0) {
                    menus.forEach((menu) => {
                        if (menu.type === BUFFET) {
                            buffetItems.push(...menu.items);
                        } else if (menu.type === ALACARTE) {
                            alacarteItems.push(...menu.items);
                        }
                    });
                }

                // Assign aggregated items back to main menus
                buffetMainMenu.items = buffetItems;
                alacarteMainMenu.items = alacarteItems;

                // Construct final menu object and update state
                const combinedMenu = {
                    [ALACARTE]: alacarteMainMenu,
                    [BUFFET]: buffetMainMenu,
                };

                this.updateMenu(combinedMenu);
                this.setState({ loading: false });
            });
    }

    render() {

        if (this.state.redirect) {
            return <Redirect to="/" />;
        }

        if (this.state.loading) {
            return <Loading />;
        }

        const { classes } = this.props;
        const { report, foodTypes } = this.state;
        const { restaurant } = report;

        return (
            <div style={{ width: '100%' }}>
                <PaddedGrid>
                    <Grid item xs={12}>
                        <Typography variant="title">
                            {this.props.t('Hävikinkirjauslomake')}
                        </Typography>
                    </Grid>

                    <PaddedGrid well>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={this.props.t('Kirjauspäivämäärä')}
                                value={FormatDate(report.date)}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label={this.props.t('Kirjaaja')}
                                value={report.reporter || ''}
                                onChange={event =>
                                    this.reportChangeHandler(event, 'reporter')
                                }
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={this.props.t('Asiakasmäärä')}
                                value={report.customers || ''}
                                onChange={event =>
                                    this.reportChangeHandler(event, 'customers')
                                }
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {this.props.t('kpl')}
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                multiline
                                fullWidth
                                label={this.props.t('Erityismerkinnät päivälle')}
                                value={report.notes || ''}
                                onChange={event =>
                                    this.reportChangeHandler(event, 'notes')
                                }
                            />
                        </Grid>
                    </PaddedGrid>

                    {(restaurant.type === BUFFET || restaurant.type === BOTH) ? (
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Valmistusmäärät ja tarjoiluhävikit')}</Typography>

                            <Table>
                                <TableHead>
                                    <TableRow style={{ fontWeight: 'bold' }}>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Ruokalajin nimi')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Kategoria')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Valmistettu ja tilattu ruokamäärä')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Tarjoiluhävikki')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Lahjoitettu')}</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {report.waste[BUFFET].map((item, i) => (
                                        <TableRow key={i} style={{ backgroundColor: (i % 2 == 0 ? '#fff' : '#eee') }}>
                                            <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                                            <TableCell>
                                                {this.props.i18n.language === 'en' ? foodTypes[item.food_type_id].name_en || foodTypes[item.food_type_id].name : foodTypes[item.food_type_id].name}
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    value={item.produced || ''}
                                                    className={classes.inputField}
                                                    style={{ width: '85px' }}
                                                    onClick={() => this.openCalculator(item.produced, (value) => {
                                                        this.wasteChangeHandler(
                                                            value,
                                                            BUFFET,
                                                            i,
                                                            'produced'
                                                        );
                                                    })}
                                                    onChange={(e) => this.wasteChangeHandler(this.numberValidate(e.target.value), BUFFET, i, 'produced')}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                kg
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    value={item.wasted || ''}
                                                    className={classes.inputField}
                                                    style={{ width: '85px' }}
                                                    onClick={() => this.openCalculator(item.wasted, (value) => {
                                                        this.wasteChangeHandler(
                                                            value,
                                                            BUFFET,
                                                            i,
                                                            'wasted'
                                                        );
                                                    })}
                                                    onChange={(e) => this.wasteChangeHandler(this.numberValidate(e.target.value), BUFFET, i, 'wasted')}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                kg
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    value={item.gifted}
                                                    className={classes.inputField}
                                                    style={{ width: '85px' }}
                                                    onClick={() => this.openCalculator(item.gifted, (value) => {
                                                        this.wasteChangeHandler(
                                                            value,
                                                            BUFFET,
                                                            i,
                                                            'gifted'
                                                        );
                                                    })}
                                                    onChange={(e) => this.wasteChangeHandler(this.numberValidate(e.target.value), BUFFET, i, 'gifted')}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                kg
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell style={{ textAlign: 'right' }}>
                                                <Delete
                                                    onClick={() =>
                                                        AppContext.prompt(() => this.destroyMenuItem(BUFFET, item.menu_item_id))
                                                    } />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <MenuItemAdder
                                open={this.state.modalAlacarte}
                                menuId={this.state.menu[BUFFET].id}
                                itemType={BUFFET}
                                restaurantId={this.restaurantId}
                                onAddedItem={(item) => this.addMenuItem(BUFFET, item)}
                                menuDate={this.state.report.date}
                                onClose={() => this.setState({ modalAlacarte: false })}
                            />

                            <Button color="primary"
                                onClick={() => this.setState({ modalAlacarte: true })}>+ {this.props.t('Lisää uusi ruokalaji')}</Button>
                        </Grid>
                    ) : ''}


                    {(restaurant.type === ALACARTE || restaurant.type === BOTH) ? (
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Ruoka-annosten valmistusmäärät')}</Typography>

                            <Table>
                                <TableHead>
                                    <TableRow style={{ fontWeight: 'bold' }}>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Ruokalajin nimi')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Kategoria')}</TableCell>
                                        <TableCell style={{ color: '#000' }}>{this.props.t('Valmistettu ja tilattu ruokamäärä')}</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {report.waste[ALACARTE].map((item, i) => (
                                        <TableRow key={i} style={{ backgroundColor: (i % 2 == 0 ? '#fff' : '#eee') }}>
                                            <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                                            <TableCell>{this.props.i18n.language === 'en' ? foodTypes[item.food_type_id].name_en || foodTypes[item.food_type_id].name : foodTypes[item.food_type_id].name}</TableCell>
                                            <TableCell>
                                                <TextField
                                                    value={item.produced || ''}
                                                    className={classes.inputField}
                                                    onClick={() => this.openCalculator(
                                                        item.produced, (value) => {
                                                            this.wasteChangeHandler(value, ALACARTE, i, 'produced');
                                                        }, 'Kpl')}
                                                    onChange={(e) => this.wasteChangeHandler(this.numberValidate(e.target.value), ALACARTE, i, 'produced')}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                {this.props.t('kpl')}
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell style={{ textAlign: 'right' }}>
                                                <Delete
                                                    onClick={() => AppContext.prompt(() => this.destroyMenuItem(ALACARTE, item.menu_item_id))} />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <MenuItemAdder
                                open={this.state.modalBuffet}
                                menuId={this.state.menu[ALACARTE].id}
                                itemType={ALACARTE}
                                restaurantId={this.restaurantId}
                                onAddedItem={(item) => this.addMenuItem(ALACARTE, item)}
                                menuDate={this.state.report.date}
                                onClose={() => this.setState({ modalBuffet: false })}
                            />

                            <Button color="primary"
                                onClick={() => this.setState({ modalBuffet: true })}>+ {this.props.t('Lisää uusi ruokalaji')}</Button>
                        </Grid>
                    ) : ''}

                    <Grid item xs={12}>
                        <Typography variant="title">{this.props.t('Keittiöhävikki')} ({this.props.t('laatu- tai toimenpidevirheen vuoksi pois heitettävä ruoka')})</Typography>

                        <Table>
                            <TableHead>
                                <TableRow style={{ fontWeight: 'bold' }}>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Ruokalajin nimi')}</TableCell>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Kategoria')}</TableCell>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Hävikin määrä')}</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {report.kitchen_waste.map((item, i) => (
                                    <TableRow key={i} style={{ backgroundColor: (i % 2 == 0 ? '#fff' : '#eee') }}>
                                        <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                                        <TableCell>{this.props.i18n.language === 'en' ? foodTypes[item.food_type_id].name_en || foodTypes[item.food_type_id].name : foodTypes[item.food_type_id].name}</TableCell>
                                        <TableCell>
                                            <TextField
                                                value={item.wasted || ''}
                                                className={classes.inputField}
                                                onClick={() => this.openCalculator(item.wasted, (value) => {
                                                    this.otherWasteChangeHandler(
                                                        'kitchen_waste',
                                                        i,
                                                        value
                                                    );
                                                })}
                                                onChange={(e) => this.otherWasteChangeHandler('kitchen_waste', i, this.numberValidate(e.target.value))}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            kg
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell style={{ textAlign: 'right' }}>
                                            <Delete
                                                onClick={() => AppContext.prompt(() => this.removeWaste('kitchen_waste', i))} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <WasteItemAdder
                            open={this.state.modalKitchenWaste}
                            onAddedItem={(item) => this.addWasteItem('kitchen_waste', item)}
                            onClose={() => this.setState({ modalKitchenWaste: false })}
                        />

                        <Button color="primary"
                            onClick={() => this.setState({ modalKitchenWaste: true })}>+ {this.props.t('Lisää uusi ruokalaji')}</Button>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="title">{this.props.t('Keittiöbiojäte')} ({this.props.t('syömäkelvoton, esim. kuoret, kannat, kahvinporot')})</Typography>
                        <TextField
                            fullWidth
                            value={report.unedible || ''}
                            onChange={event =>
                                this.reportChangeHandler(event, 'unedible', 'number')
                            }

                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        kg
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="title">{this.props.t('Varastohävikki')} ({this.props.t('kaikki poisheitetyt ruokatuotteet varastosta')})</Typography>

                        <Table>
                            <TableHead>
                                <TableRow style={{ fontWeight: 'bold' }}>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Tuotteen nimi')}</TableCell>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Kategoria')}</TableCell>
                                    <TableCell style={{ color: '#000' }}>{this.props.t('Hävikin määrä')}</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {report.storage_waste.map((item, i) => (
                                    <TableRow key={i} style={{ backgroundColor: (i % 2 == 0 ? '#fff' : '#eee') }}>
                                        <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                                        <TableCell>{this.props.i18n.language === 'en' ? foodTypes[item.food_type_id].name_en || foodTypes[item.food_type_id].name : foodTypes[item.food_type_id].name}</TableCell>
                                        <TableCell>
                                            <TextField
                                                value={item.wasted || ''}
                                                className={classes.inputField}
                                                onClick={() => this.openCalculator(item.wasted, (value) => {
                                                    this.otherWasteChangeHandler(
                                                        'storage_waste',
                                                        i,
                                                        value
                                                    );
                                                })}
                                                onChange={(e) => this.otherWasteChangeHandler('storage_waste', i, this.numberValidate(e.target.value))}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            kg
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell style={{ textAlign: 'right' }}>
                                            <Delete
                                                onClick={() => AppContext.prompt(() => this.removeWaste('storage_waste', i))} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <WasteItemAdder
                            open={this.state.modalStorageWaste}
                            onAddedItem={(item) => this.addWasteItem('storage_waste', item)}
                            onClose={() => this.setState({ modalStorageWaste: false })}
                        />

                        <Button color="primary"
                            onClick={() => this.setState({ modalStorageWaste: true })}>+ {this.props.t('Lisää uusi tuote')}</Button>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="title">{this.props.t('Asiakkaiden lautastähteet')} ({this.props.t('asiakkaiden lautasilta ylijäävä ruoka')})</Typography>
                        <TextField
                            fullWidth
                            label={this.props.t('Lautastähteet')}

                            value={report.plate_waste || ''}
                            onChange={event =>
                                this.reportChangeHandler(event, 'plate_waste', 'number')
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        kg
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                </PaddedGrid>

                <div className={classes.footerPlaceholder} />
                <Grid container spacing={24} className={classes.footerContainer}>
                    <Grid item xs={AppContext.isAdmin() ? 4 : 6} style={{ textAlign: 'center' }}>
                        <Button
                            variant="raised"
                            color="secondary"
                            onClick={() => this.saveReport()}
                        >
                            {this.props.t('Tallenna')}
                        </Button>
                    </Grid>
                    <Grid item xs={AppContext.isAdmin() ? 4 : 6} style={{ textAlign: 'center' }}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => { this.saveReport(true); this.setState({ redirect: true }); }}
                        >
                            {this.props.t('Lopeta kirjaus')}
                        </Button>
                    </Grid>
                    {AppContext.isAdmin() &&
                        <Grid item xs={AppContext.isAdmin() ? 4 : 6} style={{ textAlign: 'center' }}>
                            <Button
                                variant="raised"
                                color="secondary"
                                onClick={this.destroyReport.bind(this)}
                            >
                                {this.props.t('Poista')}
                            </Button>
                        </Grid>
                    }
                </Grid>

                <Dialog
                    open={this.state.calculatorOpen}
                    onClose={() => this.setState({ calculatorAddedValue: 0, calculatorOpen: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.calculatorTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <TextField
                                fullWidth
                                label={this.props.t('Alkuperäinen määrä')}
                                value={this.state.calculatorOriginalValue || ''}
                                onChange={this.numberValidationHandler('calculatorOriginalValue')}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {this.state.calculatorUnit}
                                        </InputAdornment>
                                    )
                                }}
                            />

                            <TextField
                                style={{ margin: '15px 0' }}
                                label={this.props.t('Lisättävä määrä')}
                                fullWidth
                                value={this.state.calculatorAddedValue || ''}
                                onChange={this.numberValidationHandler('calculatorAddedValue')}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {this.state.calculatorUnit}
                                        </InputAdornment>
                                    )
                                }}
                            />

                            <TextField
                                fullWidth
                                label={this.props.t('Uusi määrä')}

                                value={this.getCalculatorTotal() || ''}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {this.state.calculatorUnit}
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ calculatorAddedValue: 0, calculatorOpen: false })} color="primary">
                            {this.props.t('Peruuta')}
                        </Button>
                        <Button onClick={() => this.closeCalculator()} color="primary" autoFocus>
                            {this.props.t('Lisää')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

Report.propTypes = {
    match: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Report));



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Report.js